import React from "react";
import PasswordedProjects from "./PasswordedProjects";
import ScheduleDeployment from "./ScheduleDeployment";
import AnalyticsOnboarding from "./Analytics";
import Modal, { ModalContent } from "../Micro/Modal/Modal";

const OnboardingCycle = ({ team }: any) => {
  const [currentComponent, setCurrentComponent] = React.useState(0);
  const [modal, setModal] = React.useState(false);

  React.useEffect(() => {
    const onboardingComplete = localStorage.getItem(
      `${team?.id}-teamonboarding`,
    );
    if (!onboardingComplete) {
      setModal(true);
    }
  }, [team?.id]);

  React.useEffect(() => {
    if (modal && currentComponent < 3) {
      const timer = setTimeout(() => {
        setCurrentComponent((prevComponent) => prevComponent + 1);
      }, 6000);
      return () => clearTimeout(timer);
    } else if (currentComponent >= 3) {
      localStorage.setItem(`${team?.id}-teamonboarding`, String(true));
      setModal(false);
    }
  }, [modal, currentComponent, team?.id]);

  const handleClose = () => {
    if (currentComponent < 2) {
      setCurrentComponent((prevComponent) => prevComponent + 1);
    } else {
      localStorage.setItem(`${team?.id}-teamonboarding`, String(true));
      setModal(false);
    }
  };

  return (
    <div>
      <Modal
        open={modal}
        onClose={() => setModal(false)}
        className="px-5 lg:px-10"
      >
        <ModalContent className="absolute top-8 max-w-5xl sm:static sm:top-0">
          {/* {currentComponent === 0 && (
            <ScheduleDeployment handleClose={handleClose} />
          )} */}
          {currentComponent === 0 && (
            <PasswordedProjects handleClose={handleClose} />
          )}
          {currentComponent === 1 && (
            <AnalyticsOnboarding handleClose={handleClose} />
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};

export default OnboardingCycle;
